/**
 * Simple wrapper function for creating a Bootstrap modal
 * Opts:
 * - heading (just text, close button is automatically added)
 * - body (HTML)
 */

const buildIcon = require("Scripts/common/build-icon");

module.exports = createModal;

function createModal(opts) {
	const modalId = opts.id || ('modal-' + Math.random().toString(36).slice(2));
	const modalHeadingId = modalId + '-heading';

	const closeButton = '<button type="button" class="modal-close-icon" data-bs-dismiss="modal" aria-label="Close">' + buildIcon("fa-xmark", {circle:true, classes:'text-grey', attributes:{transform:'shrink-6'}}) + '</button>';

	const modalHeader = opts.heading ? '<div class="modal-header"><h2 id="' + modalHeadingId + '" class="heading-sm modal-title">' + opts.heading + '</h2>' + closeButton + '</div>' : closeButton;

	const modalHtml = '<div id="' + modalId + '" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" ' + (opts.heading ? 'aria-labelledby="' + modalHeadingId + '"' : '') + '>' + 
		'<div class="modal-dialog">' +
			'<div class="modal-dialog">' +
				'<div class="modal-content">' +
					modalHeader + 
					'<div class="modal-body">' + opts.content + '</div>' +
				'</div>' +
			'</div>' +
		'</div>' + 
	'</div>';

	$('body').append(modalHtml);
}